import { render } from "./projectext0.vue?vue&type=template&id=3bff8514&scoped=true"
import script from "./projectext0.vue?vue&type=script&lang=js"
export * from "./projectext0.vue?vue&type=script&lang=js"

import "./projectext0.vue?vue&type=style&index=0&id=3bff8514&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bff8514"]])

export default __exports__